import "form-request-submit-polyfill";
if (typeof HTMLFormElement !== "undefined") {
    /*
        Source: https://gist.github.com/mcshaz/c65040c11e6daffe356cbedb7ec84ce4
        Authors: Brent McSharry
    */
    if (!HTMLFormElement.prototype.reportValidity) {
        HTMLFormElement.prototype.reportValidity = function () {
            if (this.checkValidity()) {
                return true;
            }
            if (this.noValidate) {
                this.noValidate = false;
                this.requestSubmit();
                this.noValidate = true;
            } else {
                this.requestSubmit();
            }
            return false;
        };
    }

    /*
        Source: https://gist.github.com/nuxodin/73a2c2423cbbf6818c28ad803985d5c7
        Authors: Tobias Buschor, Luke Scott
    */
    if (!HTMLInputElement.prototype.reportValidity) {
        HTMLInputElement.prototype.reportValidity = function () {
            if (this.checkValidity()) return true;
            var form = this.form;
            var tmpForm;
            if (!form) {
                tmpForm = document.createElement("form");
                tmpForm.style.display = "inline";
                this.before(tmpForm);
                tmpForm.append(this);
            }
            var siblings = Array.from(form.elements).filter(function (input) {
                return input !== this && !!input.checkValidity && !input.disabled;
            }, this);
            siblings.forEach(function (input) {
                input.disabled = true;
            });
            form.reportValidity();
            siblings.forEach(function (input) {
                input.disabled = false;
            });
            if (tmpForm) {
                tmpForm.before(this);
                tmpForm.remove();
            }
            this.focus();
            this.selectionStart = 0;
            return false;
        };
    }
}